import React, {useState} from 'react';
import './style.css';

const DashboardMetricDisplayLarge = ({ value, subtext }) => {

    return (
        <div class="dashboard-metric-display-large-container">
            <h1>{value}</h1>
            <p>{subtext}</p>
        </div>
    );
}

export { DashboardMetricDisplayLarge };